<template>
    <div>
        <label><input type="checkbox" v-model="block.showInNavigation" ref="showInNavigation"> In Navigation
            anzeigen</label>
        <text-input :value="block.name" label="Name" ref="name"/>
        <long-text-input :value="block.text" label="Text" ref="text"/>
        <div class="admin-info">
            <ul>
              <li>Als Zwischentitel <b>immer</b> den zweiten Überschriftgrad verwenden (##).</li>
                <li>Hoch- und Tiefgestellter Text kann mit &lt;sup&gt;Hoch&lt;/sup&gt; resp. &lt;sub&gt;Tief&lt;/sub&gt;
                    realisiert werden.
                </li>
                <li>Bilder können mit [img id=ID align=[left|right|center] size=[1|2|3]] eingebunden werden. Die Bilder
                    müssen unter "Generelle Texte" hinterlegt werden und die ID wird angezeigt, wenn man auf das
                    hochgeladene Bild klickt. Ein Bild mit der ID 999 wird z.b. folgendermassen eingebunden:<br>
                    <b>[img id=999 align=left size=2]</b>
                </li>
                <li>Ein Projekt mit der Nummer <b>XY</b> kann mit folgendem Code im Text verlinkt werden: <b>[project
                    number=XY]</b>.
                </li>
                <li>Ein Tag mit der ID <b>XY</b> kann mit folgendem Code im Text verlinkt werden: <b>[tag id=XY]</b>.
                </li>
            </ul>
        </div>
        <hr>
        <file-input v-model="block.image" label="Bild" type="image"/>
        <div class="admin-info">
            <ul>
                <li>Dieses Bild bitte <b>nur</b> nochladen, falls das Bild neben dem Text dargestellt werden soll. Der
                    Abschnitt wird dann zweispaltig, links das Bild und rechts der Text.
                </li>
            </ul>
        </div>
        <hr>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>
<script>
export default {
  props: ["project", "blockData"],
  data() {
    return {
      block: this.blockData
    };
  },
  methods: {
    save() {
      let form = new FormData();
      if (this.block.image && this.block.image.id) {
        form.append("edit_image_block[image]", this.block.image.id);
      } else {
        form.append("edit_image_block[image]", "");
      }
      if (this.block.showInNavigation)
        form.append(
          "edit_image_block[showInNavigation]",
          this.block.showInNavigation
        );
      form.append("edit_image_block[submit]", 1);

      Promise.all([
        this.$refs.name.save(),
        this.$refs.text.save(),
        axios.post(
          "/api/" + store.state.language + "/block/" + this.block.id + "/edit",
          form
        )
      ]).then(() => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Blocks/ImageBlock.vue